/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PerfEnergyKpiPeriod } from '../../models/perf-energy-kpi-period';

export interface GetPerfEnergyKpIs$Any$Params {
  
    /**
     * Body for search kpi
     */
    body?: any
}

export function getPerfEnergyKpIs$Any(http: HttpClient, rootUrl: string, params?: GetPerfEnergyKpIs$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PerfEnergyKpiPeriod>>> {
  const rb = new RequestBuilder(rootUrl, getPerfEnergyKpIs$Any.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PerfEnergyKpiPeriod>>;
    })
  );
}

getPerfEnergyKpIs$Any.PATH = '/custom/kpi/perf-energy';
